/**
 * When a proposal card is finished with, and when it is being asked a question.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * WHY THIS IS ITS OWN FILE
 *
 * It is four lines and it lived inside a catch block in useAgentChat, which
 * meant nothing could test it: importing that hook drags in React and the app's
 * path aliases, so a check script cannot reach the one decision that matters.
 * Here it has no imports at all and both sides can read it.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * THE DISTINCTION
 *
 * Two outcomes come back down the same path and mean opposite things.
 *
 * DEAD: already applied, already discarded, expired, or replaced by a newer
 * proposal. No press can ever work again, so the card settles. Putting its
 * buttons back is a lie, and it is the lie a customer filmed off his screen: he
 * staged three expenses from bank screenshots, pressed Apply, the server refused
 * with "status SUPERSEDED", the buttons returned, and from where he sat the
 * product had ignored him. With several cards up at once, every stale one was
 * inviting a press that could only fail.
 *
 * LIVE: a duplicate warning. The server deliberately put that card back to
 * PENDING because the second press IS the confirmation it wants. Retiring it
 * would throw away the answer it is waiting for.
 */

/** Error codes that mean the proposal is finished with, whatever the outcome. */
export const DEAD_PROPOSAL_CODES = [
  'APPROVAL_ALREADY_DECIDED',
  'APPROVAL_EXPIRED',
  'APPROVAL_NOT_FOUND',
] as const;

export function isDeadProposal(code: string): boolean {
  return (DEAD_PROPOSAL_CODES as readonly string[]).includes(code);
}
